export const GET_CURRENCY_INFO_SUCCESS = "GET_CURRENCY_INFO_SUCCESS"
export const GET_CURRENCY_INFO = "GET_CURRENCY_INFO"
export const SET_CURRENCY_INFO = "SET_CURRENCY_INFO"

export interface GetCurrencyInfoResponseBody {
    result: {
        locale: string;
        currencyCode: string;
        currencySymbol: string;
    },
    message: string;
    isSuccess: boolean;
}